import { AuthGuard } from '@core/auth/auth.guard';
import { RoleGuard } from '@core/auth/role.guard';
import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./presentation/auth/auth.routes').then(m => m.authRoutes) },
  { path: 'participants', loadComponent: () => import('./presentation/admin/participant-management/participant-management.component').then(m => m.ParticipantManagementComponent), canActivate: [AuthGuard] },
  { path: 'sessions', loadComponent: () => import('./presentation/session/session-page.component').then(m => m.SessionPageComponent), canActivate: [AuthGuard] },
  { path: 'admin', loadChildren: () => import('./presentation/admin/admin.routes').then(m => m.adminRoutes), canActivate: [AuthGuard, RoleGuard] },
  { path: 'dashboard', loadComponent: () => import('./presentation/dashboard/dashboard.component').then(m => m.DashboardComponent), canActivate: [AuthGuard] },
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
];